import useFrontendBoot from "@/Hooks/useFrontendBoot";
import { createContext, useEffect, useState } from "react";
import { IGlobalThemeContextProviderProps } from "../themeContext.type";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { IThemeSchema } from "@/Pages/Theme/theme.types";

export const GlobalThemeContext = createContext<IThemeSchema | null>(null);

export default function GlobalThemeContextProvider({
  children,
}: IGlobalThemeContextProviderProps) {
  const { frontendBootService, partnerFrontendBootService } = useFrontendBoot();
  const [theme, setTheme] = useState<IThemeSchema | null>(null);
  // HOOK/s
  // This will update theme css variables
  useEffect(() => {
    if (import.meta.env.VITE_USER == "partner") {
      const partnerTheme =
        partnerFrontendBootService?.data?.data?.selected_theme;
      setTheme(partnerTheme);
    } else if (import.meta.env.VITE_USER == "broker") {
      const brokerTheme = frontendBootService?.data?.data?.settings?.theme;
      setTheme(brokerTheme);
    }

    if (theme) {
      const root = document.documentElement;
      root.style.setProperty(
        "--color-primary",
        stringUtility.hexToRgbUtility(theme?.primary_color)
      );
      root.style.setProperty(
        "--color-secondary",
        stringUtility.hexToRgbUtility(theme?.secondary_color)
      );
      root.style.setProperty(
        "--color-tertiary",
        stringUtility.hexToRgbUtility(theme?.tertiary_color)
      );
      root.style.setProperty(
        "--color-success",
        stringUtility.hexToRgbUtility(theme?.success_color)
      );
      root.style.setProperty(
        "--color-error",
        stringUtility.hexToRgbUtility(theme?.error_color)
      );
      root.style.setProperty(
        "--color-info",
        stringUtility.hexToRgbUtility(theme?.info_color)
      );
      root.style.setProperty(
        "--color-warning",
        stringUtility.hexToRgbUtility(theme?.warning_color)
      );
    }
  }, [frontendBootService?.data || partnerFrontendBootService?.data, theme]);

  return (
    <GlobalThemeContext.Provider value={theme}>
      {children}
    </GlobalThemeContext.Provider>
  );
}
